import {
  faFileSignature,
  faShieldAlt,
  faSignInAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import style from "../../assets/css/components/Header/Header.module.css";
import LogoHeader from "./LogoHeader";
import tinycolor from "tinycolor2";
import Swal from "sweetalert2";
import classNames from "classnames";

function Header({ nameTeam, teamColor, tournament }) {
  const navigate = useNavigate();
  const role = window.localStorage.getItem("role");
  const [menu, setMenu] = useState(false);

  const signOut = () => {
    try {
      Swal.fire({
        title: "¿Quieres cerrar sesión?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Si, cerrar sesión",
        denyButtonText: `Cancelar`,
      }).then((result) => {
        if (result.isConfirmed) {
          logoutAction();
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const logoutAction = () => {
    window.localStorage.clear();
    navigate("/");
  };

  const goToLogin = () => {
    navigate("/admin");
  };

  return (
    <div className={style.header}>
      <LogoHeader />
      <div className={style.team}>
        <div className={style.infoTeam}>
          <p className={style.name}>{nameTeam}</p>
          <p className={style.league}>{tournament}</p>
        </div>
        <div
          className={
            role !== "admin"
              ? classNames(style.shield, style.cursor)
              : style.shield
          }
          onClick={
            role === "leader"
              ? () => setMenu(!menu)
              : role !== "Admin"
              ? goToLogin
              : null
          }
          style={{
            background:
              tinycolor.readability("#17171d", teamColor) <= 2
                ? "#00dd80"
                : "#17171d",
            border: `1px solid ${teamColor}`,
          }}
        >
          <p className={style.icon}>
            <FontAwesomeIcon icon={faShieldAlt} color={teamColor} />
          </p>
        </div>
        {role === "leader" ? (
          <div
            className={
              menu ? classNames(style.menu, style.showMenu) : style.menu
            }
          >
            <div className={style.itemMenu} onClick={() => setMenu(!menu)}>
              <Link
                className={style.link}
                to={"/terms"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className={style.text}>
                  <span>
                    <FontAwesomeIcon icon={faFileSignature} />
                  </span>
                  Reglamento del torneo
                </p>
              </Link>
            </div>
            <div
              className={style.itemMenu}
              onClick={role === "leader" ? signOut : null}
            >
              <p className={style.text}>
                <span>
                  <FontAwesomeIcon icon={faSignInAlt} />
                </span>
                Cerrar sesión
              </p>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Header;
